import angular from 'angular';
import { countBy, forEach, get, some, find, isString, filter } from 'lodash';
import moment from 'moment-timezone';
import '../app.constants';
import '../resources/subscription';
import '../services/globals';
import '../services/errors';
import '../services/subscription';
import '../services/line';
import '../services/area';
import '../services/queue';
import '../services/user';
import '../services/notifications';
import './modals/enqueue';
import './modals/info';
import './modals/assign-user';
import './modals/forward';
import '../components/carousel';

const module = angular.module('whyline.controllers.queue', [
  'whyline.constants',
  'whyline.resources.subscription',
  'whyline.services.globals',
  'whyline.services.errors',
  'whyline.services.subscription',
  'whyline.services.line',
  'whyline.services.area',
  'whyline.services.queue',
  'whyline.services.user',
  'whyline.services.notifications',
  'whyline.modals.enqueue',
  'whyline.modals.info',
  'whyline.modals.assign-user',
  'whyline.modals.forward',
  'whyline.components.carousel',
]);

const QueueController = (
  QueueService,
  UserService,
  SubscriptionService,
  ErrorService,
  GlobalsService,
  NotificationService,
  PlaceService,
  OrganizationService,
  $scope,
  $uibModal,
  $state,
  $timeout,
  $translate,
  dialog,
  $rootScope,
  screenSize,
) => {
  /* @ngInject */

  const { lineId, areaId } = $state.params;
  const userId = UserService.GetCurrent()._id;
  let enqueueIn = {};
  const organization = OrganizationService.GetCurrent();
  $scope.quantityOfItems = 8;
  $scope.choosingCompletionState = {};
  $scope.subscriptions = {};
  $scope.processing = {};
  $scope.showComplete = false;
  $scope.canCall = false;
  $scope.canDone = true;
  $scope.showTrackingData = false;
  $scope.extraData = {};
  $scope.subscriptionsAmount = {
    waiting: 0,
    done: 0,
    inPlace: 0,
  };
  const size = screenSize.get();
  $scope.showHr = size === 'xs' || size === 'sm' ? true : false;
  $scope.filters = [
    { key: 'total', label: 'total in line' },
    { key: 'inPlace', label: 'in place' },
  ];
  $scope.promise = null;
  $scope.allowMultipleSubscriptions = false;
  const allCustomFields = get(organization, 'configuration.customFields', []);
  $scope.customFields = allCustomFields.length ? filter(allCustomFields, c => c.showInAlias) : null;
  $scope.userPreferenceEnabled = get(organization, 'configuration.userPreferenceEnabled', false);
  PlaceService.GetCurrentAsPromise().then((place) => {
    $scope.allowMultipleSubscriptions = place.configuration.allowMultipleSubscriptions;
    $scope.hasToHidePersonalDataFields = UserService.HasToHidePersonalDataFields(place._id);
    $scope.filterData = {
      showFilters: place.configuration.showWaitingInLineInPlace,
      selectedFilter: 'total',
    };
    $scope.aliasType = place.configuration.aliasType;
    $scope.checkDurationCompleteAction = get(place, 'configuration.checkDurationCompleteAction', {});
  });
  $scope.applyFilter = (filter) => {
    $scope.filterData.selectedFilter = filter.key;
  };
  $scope.filterSubscriptions = (item) => {
    if (item) {
      switch ($scope.filterData.selectedFilter) {
        case 'total':
          return true;
        case 'inPlace':
          return item.statusInfo.reason === 'checked-in';
        default:
        // no default
      }
    }
  };

  screenSize.on('xs, sm', function (isMatch) {
    $scope.showHr = isMatch;
  });

  $scope.toggleShowComplete = () => {
    $scope.showComplete = !$scope.showComplete;
  };

  $scope.metadata = { data: [] };

  $scope.getShowName = SubscriptionService.getShowName;

  const getSubscriptionsAmount = (subscriptions) => {
    forEach(subscriptions, (value, key) => {
      if (value.status === 'canceled' && value.reason === 'queue-clear') {
        Reflect.deleteProperty(subscriptions, key);
      }
    });
    const amount = countSubscriptionBy(subscriptions, 'status');
    const amountReason = countSubscriptionBy(subscriptions, 'statusInfo.reason');
    $scope.subscriptionsAmount.waiting = amount.waiting || 0;
    $scope.subscriptionsAmount.done = (amount.completed || 0) + (amount.canceled || 0);
    $scope.subscriptionsAmount.inPlace = amountReason['checked-in'] || 0;
    if ($scope.currentQueue) {
      const current = {
        _id: $scope.currentQueue._id,
        waiting: $scope.subscriptionsAmount.waiting,
        type: $scope.currentQueue.type,
      };
      $rootScope.$broadcast('update-active-queue', { currentQueue: current });
    }
  };

  const countSubscriptionBy = (subscriptions, by) => {
    const result = {};
    
    for(const index in subscriptions){

      const subs = subscriptions[index];

      const counter = get(subs, by, null);
      const people = get(subs, 'people', 1);

      if(!counter){
        continue;
      }

      if(result[counter]) {
        result[counter] += people;
      } else {
        result[counter] = people;
      }
    }
    return result;
  }

  const getSubscritionMetadata = (subscription) => {
    $timeout(async () => {
      try {
        $scope.metadata.data = [];
        if (!subscription || !subscription._id) {
          return;
        }

        const _id = isString(subscription) ? subscription : subscription._id;

        const response = await SubscriptionService.getSubscritionMetadata(_id);

        $scope.$apply(() => {
          const {
            status,
            data: { metadata },
          } = response;

          const isNotOk = status !== 200;

          $scope.metadata.data = isNotOk
            ? []
            : metadata.map((data) =>
                Object.keys(data)
                  .reduce((d, k) => {
                    d[k] = data[k].replace(/\\n/gi, '\n');
                    return d;
                  }, {}),
              );
        });
      } catch (err) {
        console.log('getSubscritionMetadata, err =>', err);
      }
    });
  };

  // Get the processing subscription
  $scope.$watch(
    'subscriptions',
    (newVal) => {
      // Update if someone is processing
      $scope.processing = find(newVal, {
        status: 'processing',
        calledBy: userId,
      });
      $scope.counter = 0;
      if ($scope.processing && $scope.processing.calledTime) {
        const now = moment();
        const called = moment($scope.processing.calledTime);
        const diff = now.diff(called, 'seconds');
        $scope.counter = diff;
      }
      $scope.showTimer = $scope.showAttentionTimer && $scope.processing;
      $scope.extraData = {};
      $scope.promise = null;
      if($scope.processing && $scope.processing.extraData && $scope.processing.extraData.tracking && !$scope.promise){
        $scope.promise =  SubscriptionService.GetExternalData($scope.processing.extraData.tracking);
      } else {
        $scope.showTrackingData = false;
        $scope.extraData = {};
      }
      if($scope.promise){
        $scope.promise.then(response => {
          $scope.showTrackingData = true;
          $scope.extraData = response;
        })
      }
      if ($scope.processing && !$scope.processing.fullName) {
        $scope.processing.fullName = $scope.getShowName($scope.processing);
      }

      // Enable the call next button
      $scope.canCall = some(newVal, (sub) => sub.status === 'waiting' && sub.checkIn.checkedIn);

      // Get amount of subscriptions acording with type (done, waiting...)
      getSubscriptionsAmount(newVal);

      getSubscritionMetadata($scope.processing);
    },
    true,
  );

  // Set the current queue according with the params.
  if (!lineId && !areaId) {
    // If there are not params, then set the first object of the linesAndAreas object as the current.
    QueueService.SetCurrent($scope.lines[0] || $scope.areas[0]);
    $scope.getShowTimer();
  } else {
    QueueService.GetQueueById({
      lineId,
      areaId,
    })
      .then((queue) => {
        if (queue.realType === 'process') {
          queue.disabledAddPersonFromProcess = !queue.isWithoutAppointment;
        }

        if (queue.realType !== 'supervisor') {
          enqueueIn = {
            where: queue.realType,
            lineId: queue.realType === 'line' ? queue._id : undefined,
            areaId: queue.realType === 'process' ? queue._id : undefined,
          };
          if (queue.realType === 'process') {
            $scope.filterData.showFilters = false;
          }
        }
        if (queue.realType === 'supervisor') {
          enqueueIn = {
            where: 'line',
            lineId: queue._id,
          };
        }
        // Set the current queue that I got by id
        QueueService.SetCurrent(queue);
        // Added the current queue to the scope
        $scope.currentQueue = QueueService.currentQueue;
        $scope.getShowTimer();
        // Get permissions
        if (QueueService.currentQueue && QueueService.currentQueue._id) {
          $scope.permissions = UserService.GetPermissions(
            GlobalsService.CurrentPlace._id,
            QueueService.currentQueue._id,
          );
        }

        // Get subscriptions for the current queue.
        $scope.subscriptions = SubscriptionService.GetAllByQueue(QueueService.currentQueue, {
          force: true,
        });
      })
      .catch(ErrorService.handler);
  }

  $scope.getShowTimer = () => {
    if ($scope.currentQueue && $scope.currentQueue.realType === 'line') {
      $scope.showAttentionTimer = get(
        $scope.currentQueue,
        'configuration.showAttentionTimer',
        false,
      );
    }
  };

  $scope.counter = 0;
  $scope.onTimeout = () => {
    $scope.counter++;
    const dateAtZero = new Date().setHours(0, 0, 0, 0);
    $scope.date = new Date(dateAtZero).setSeconds($scope.counter);
    $timeout($scope.onTimeout, 1000);
  };
  $timeout($scope.onTimeout, 1000);
  /**
   * Modals
   */
  // Modal to show user (subscription) info
  $scope.info = (subscriptionId) => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/subscription-modal.html',
      size: 'md',
      controller: 'InfoController',
      resolve: {
        // don't replace with 'short-hand'!
        subscriptionId: () => subscriptionId,
        currentPlaceId: () => GlobalsService.CurrentPlace._id,
      },
    });
  };

  $scope.assignUser = (subscription) => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/assign-user-modal.html',
      size: 'md',
      controller: 'AssignUserController',
      resolve: {
        subscription: () => subscription,
        currentPlaceId: () => GlobalsService.CurrentPlace._id,
      },
    });
  };

  // Modal to enqueue/add user to line
  $scope.openEnqueueModal = () => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/subscription-enqueue.html',
      size: 'md',
      controller: 'EnqueueController',
      resolve: {
        enqueueIn: () => enqueueIn,
        currentPlace: () => PlaceService.GetOneAsPromise(GlobalsService.CurrentPlace._id),
        currentOrganization: () => OrganizationService.GetCurrent(),
      },
    });
  };

  // Modal to enqueue/add user to line
  $scope.openForwardModal = (subscription) => {
    $scope.counter = 0;
    const datetext = new Date($scope.date).toTimeString().split(' ')[0];
    $uibModal.open({
      templateUrl: '/templates/components/modals/subscription-forward.html',
      size: 'md',
      controller: 'ForwardController',
      resolve: {
        subscription: () => subscription,
        line: () => QueueService.currentQueue,
      },
    });
  };

  $scope.openRetainModal = (subscription, expirationDays) => {
    let daysLeft = expirationDays;

    if (subscription.retained.expirationDate) {
      const today = moment().startOf('day');
      const lastDay = moment(subscription.retained.expirationDate).startOf('day');
      daysLeft = lastDay.diff(today, 'days');
    }

    const daysText = daysLeft < 2 ? $translate.instant('day') : $translate.instant('days');
    const infoText = `${$translate
      .instant('retain_for_{days}')
      .replace('{days}', daysLeft)} ${daysText}`;

    dialog.reason(infoText).then((reason) => {
      SubscriptionService.Retain(subscription._id, QueueService.currentQueue._id, reason).catch(
        ErrorService.handler,
      );
    });
  };

  $scope.rejoin = (subscription) => {
    const name = $scope.getShowName(subscription);

    dialog.confirm($translate.instant('rejoin_{name}_sure').replace('{name}', name)).then(() => {
      // @TODO add translation to this notification
      NotificationService.Information(`Re-enviando a ${name}.`);
      SubscriptionService.Rejoin(subscription);
    });
  };

  /**
   * Refactored
   */
  // Forward subscription to supervisor
  $scope.forwardSubscription = (subscription) => {
    const name = $scope.getShowName(subscription);

    // First, ask the user if really wants to forward a subscription
    dialog
      .confirm($translate.instant('derive_{name}_supervisor_sure').replace('{name}', name))
      .then(() => {
        // Use the SubscriptionService to forward a subscription
        SubscriptionService.Forward(subscription._id, QueueService.currentQueue)
          .then(() => {
            $timeout(() => {
              const text = $translate.instant('user_{name}_derived_succ').replace('{name}', name);
              NotificationService.Success(text, $translate.instant('success'));
            });
          })
          .catch(ErrorService.handler);
      });
  };

  // Remove subscription
  $scope.removeSubscription = (subscription) => {
    const n = $scope.getShowName(subscription);

    dialog
      .confirm($translate.instant('list_remove_{name}_sure').replace('{name}', n))
      .then(() => {
        SubscriptionService.Remove(subscription._id, QueueService.currentQueue)
          .then(() => {
            NotificationService.Success(
              $translate.instant('list_{name}_remove_succ').replace('{name}', n),
            );
          })
          .catch(ErrorService.handler);
      })
      .catch((res) => res);
  };

  // Call next subscription in the list
  $scope.callNext = () => {
    $scope.pressedCallNext = moment();
    $scope.canDone = false;
    QueueService.CallNext(QueueService.currentQueue)
      .then(() => {
        $scope.showComplete = false;
        NotificationService.Success(
          $translate.instant('person_call_succ'),
          $translate.instant('success'),
        );
        $timeout(() => {
          $scope.canDone = true;
        }, 3000);
      })
      .catch(ErrorService.handler);
  };

  // Call a specific subscription by id
  $scope.callTo = (subscriptionId) => {
    $scope.pressedCallNext = moment();
    $scope.canDone = false;
    QueueService.CallTo(subscriptionId, QueueService.currentQueue)
      .then(() => {
        $scope.showComplete = false;
        NotificationService.Success(
          $translate.instant('person_call_succ'),
          $translate.instant('success'),
        );
        $timeout(() => {
          $scope.canDone = true;
        }, 3000);
      })
      .catch( error => {
        if(error.status === 406 && error.data === "queue.call-to.somebody-is-processing"){
          $scope.canDone = true;
        }
        ErrorService.handler(error);
      });
  };

  $scope.endSubscriptionFn = (subscription , status, reason) => {
    SubscriptionService.EndSubscription(subscription , status, reason)
      .then(() => {
        $timeout(() => {
          $scope.showTrackingData = false;
          $scope.toggleShowComplete();
        });
      })
      .catch(ErrorService.handler)
  };

  // Done a processing subscription
  // (options: complete, rejected or absent)
  $scope.endSubscription = (subscription, status, reason) => {
    $scope.counter = 0;
    const datetext = new Date($scope.date).toTimeString().split(' ')[0];
    if(get($scope.checkDurationCompleteAction, 'enabled', false)) {
      const diff = moment().diff(subscription.calledTime, 'seconds');
      const showMessageBeforeSeconds = get($scope.checkDurationCompleteAction, 'showMessageBeforeSeconds', 0)
      if(showMessageBeforeSeconds > 0 && showMessageBeforeSeconds > diff) {
        dialog
          .confirm($translate.instant('you_are_completing_attention_in_less_than_{seconds}_seconds').replace('{seconds}', showMessageBeforeSeconds))
          .then(() => $scope.endSubscriptionFn(subscription, status, reason))
          .catch(() => 'canceled');
      } else {
        $scope.endSubscriptionFn(subscription, status, reason);
      }
    } else {
      $scope.endSubscriptionFn(subscription, status, reason);
    }   
  };

  $scope.requeue = (subscription) => {
    const name = $scope.getShowName(subscription);

    dialog
      .confirm($translate.instant('confirm_requeue_{name}').replace('{name}', name))
      .then(() => {
        SubscriptionService.Requeue(subscription)
          .then(() => {
            NotificationService.Success(
              $translate.instant('requeue_success'),
              $translate.instant('success'),
            );
          })
          .catch(ErrorService.handler);
      });
  };

  $scope.subscriptionDisabledForPreference = (subscription) => {
    if ($scope.userPreferenceEnabled) {
      const currentQueue = QueueService.currentQueue;
      const preference = subscription.userPreferences.find(up => up.lineId === currentQueue._id);
      if (preference) {
        return preference.userId !== userId;
      }
    }
    return false;
  }
};

export default module.controller('QueueController', QueueController);
